import AnnouncementBanner from 'components/admin/Announcements/AnnouncementBanner';
import {
  logAnnouncementCTAClicked,
  logAnnouncementDismissed,
} from 'components/admin/Announcements/eventUtil';
import { AnnouncementType } from 'components/admin/Announcements/utils';
import React from 'react';
import {
  Notification as NotificationInterface,
  useLegacyNotifications,
} from '../../controllers/contexts/legacyGlobalNotifications';

export const ConvertedBanner = ({
  id,
  data: { closeable, color, message, primaryAction },
}: NotificationInterface): JSX.Element => {
  const { removeNotification } = useLegacyNotifications();
  const primaryActionCallback = primaryAction?.onClick;

  return (
    <AnnouncementBanner
      bodyText={message}
      color={color}
      key={`banner-${id}`}
      id={id}
      data-cy={`banner-id-${id}`}
      onDismiss={
        closeable
          ? () => {
              logAnnouncementDismissed({
                bannerContent: message,
                id,
              });
              removeNotification(id);
            }
          : undefined
      }
      primaryAction={
        primaryActionCallback
          ? {
              ...primaryAction,
              onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                logAnnouncementCTAClicked({
                  bannerContent: message,
                  event,
                  id,
                });
                primaryActionCallback(event);
              },
            }
          : primaryAction
      }
    />
  );
};

/* END LEGACY BANNER */

const BANNERS_LIMIT = 3;

const LegacyGlobalBannerList = (): JSX.Element => {
  const { notifications } = useLegacyNotifications();
  const filteredAppTypeNotifications = notifications.filter(
    (notification) =>
      !notification.data.announcementType ||
      notification.data.announcementType === AnnouncementType.APP_WIDE,
  );

  return (
    <>
      {filteredAppTypeNotifications
        .slice(0, BANNERS_LIMIT)
        .map((notification) => {
          return (
            <ConvertedBanner
              key={`banner-${notification.id}`}
              {...notification}
            />
          );
        })}
    </>
  );
};

export default LegacyGlobalBannerList;
